// extracted by mini-css-extract-plugin
module.exports = {"showResult":"NotPermission_showResult__1sVKp","icon":"NotPermission_icon__1uSmk","message":"NotPermission_message__3v1Py"};